import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";

/**
 * A row entity in the about-products table: feature metadata plus availability
 * flags keyed by custom-product id or bundle id
 */
export type AboutProductsTableEntity = {
  id: string;
  featureName: string;
  featureIdentity: string;
  featureDescription: string;
  [productOrBundleId: string]: boolean | string;
};

/** The column definition for the about-products table with the field property typed */
export type AboutProductsTableGridColDef = DataGridCellParams<
  AboutProductsTableEntity,
  AboutProductsTableColumnField
>;

/** The static column fields that can be used in the about-products table */
export type AboutProductsTableColumnField = "featureName" | "featureIdentity";

/** The labels for the static columns in the about-products table */
export const ABOUT_PRODUCTS_TABLE_COLUMN_LABELS: Record<
  AboutProductsTableColumnField,
  string
> = {
  featureName: "Feature Name",
  featureIdentity: "Feature Identity",
};

/** A change of one feature's membership in one bundle, waiting to be confirmed by the user */
export interface BundleFeatureChange {
  /** The bundle the feature is added to or removed from */
  bundle: FaroCoreApiTypes.AdmBundle;

  /** The feature that is added or removed */
  featureId: FaroCoreApiTypes.AdmFeature["id"];

  /** The name of the feature, shown in the confirmation dialog */
  featureName: string;

  /** Whether the feature is added to the bundle or removed from it */
  shouldAdd: boolean;
}

/** Called when the user asks to change a feature's membership in a bundle */
export type BundleFeatureChangeHandler = (change: BundleFeatureChange) => void;
